import request from '@/utils/request'

/* ===== 协议模板（仅机构管理员） ===== */

// 模板列表
export function templateList() {
  return request.post('/agreement/templateList')
}

// 模板新增/修改：POST id name content params seal status remark
export function templateSave(data) {
  return request.post('/agreement/templateSave', data)
}

// 模板详情（编辑回显）：POST id
export function templateDetail(id) {
  return request.post('/agreement/templateDetail', { id })
}

// 模板删除：POST id
export function templateDelete(id) {
  return request.post('/agreement/templateDelete', { id })
}

/* ===== 协议实例 ===== */

// 生成协议：POST order_id template_id title extra_params
export function agreementGenerate(data) {
  return request.post('/agreement/generate', data)
}

// 协议列表：POST sign_status order_id page limit
export function agreementList(data) {
  return request.post('/agreement/index', data)
}

// 协议详情：POST id
export function agreementDetail(id) {
  return request.post('/agreement/detail', { id })
}

// 签署状态流转：POST id sign_status(1已发送 2已签署)
export function agreementSign(id, signStatus) {
  return request.post('/agreement/sign', { id, sign_status: signStatus })
}

// 删除协议（仅机构管理员）：POST id
export function agreementDelete(id) {
  return request.post('/agreement/delete', { id })
}

/* ===== 客户签署（免登录，带 token 鉴权） ===== */

// 客户扫码查看协议：GET agreement_id token
export function agreementQrView(agreementId, token) {
  return request.get('/agreement/qrview', { params: { agreement_id: agreementId, token } })
}

// 客户在线签署：POST agreement_id token signature
export function agreementQrSign(data) {
  return request.post('/agreement/qrSign', data)
}

// 保存已签署协议 PDF 存档：POST agreement_id token pdf(base64 dataURL)
export function agreementSavePdf(data) {
  return request.post('/agreement/savePdf', data)
}